'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.clickedViralLink = exports.toggleOpenAction = undefined;
exports.toggleOpen = toggleOpen;

var _reduxActions = require('redux-actions');

var _getIsOpen = require('../selectors/getIsOpen');

var _VisitorActionTypes = require('../constants/VisitorActionTypes');

var ActionTypes = _interopRequireWildcard(_VisitorActionTypes);

var _trackInteraction = require('../usage-tracking/actions/trackInteraction');

var _handleOpenChange = require('../post-message/actions/handleOpenChange');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var toggleOpenAction = exports.toggleOpenAction = (0, _reduxActions.createAction)(ActionTypes.TOGGLE_OPEN, function (isOpened) {
  return {
    isOpened: isOpened
  };
});

function toggleOpen(isOpened) {
  return function (dispatch, getState) {
    if (isOpened !== (0, _getIsOpen.getIsOpen)(getState())) {
      dispatch((0, _trackInteraction.trackInteraction)('widget-interaction', {
        action: isOpened ? 'open widget' : 'close widget'
      }));
    }

    dispatch(toggleOpenAction(isOpened));

    dispatch((0, _handleOpenChange.handleOpenChange)(isOpened));
  };
}

var clickedViralLink = exports.clickedViralLink = (0, _reduxActions.createAction)(ActionTypes.CLICK_VIRAL_LINK);


//////////////////
// WEBPACK FOOTER
// ./js/actions/WidgetActions.js
// module id = 349
// module chunks = 2 3